
import barba from '@barba/core';
export default class{

    constructor(){
        
        barba.hooks.once((data) => {
            this.init()
        })
        barba.hooks.enter((data) => {

            this.init()
        });
    }
    init (){
        const allChecked = document.querySelectorAll("[data-all-checked-button]")
        if( allChecked.length > 0 ){
            allChecked.forEach(el => {
                el.addEventListener("click",() => {
                    const names = el.getAttribute("data-all-checked-button")
                    const items = document.querySelectorAll("[name='" + names + "']")
                    const isActive = (el.classList.contains("-active")) ? true : false
                    
                    if(isActive){
                        el.classList.remove("-active")
                    }else{
                        el.classList.add("-active")
                    }

                    items.forEach(item => {
                        item.checked = !isActive
                    })
                })

                const names = el.getAttribute("data-all-checked-button")
                const items = document.querySelectorAll("[name='" + names + "']")
                
                let isAll = true
                Array.from(items).some(item => {
                    if( !item.checked ){
                        isAll = false
                        return true
                    }
                })
                if(isAll){
                    el.classList.add("-active")
                }else{
                    el.classList.remove("-active")
                }
            })
        }

        const checkItems = document.querySelectorAll("[data-check-items]")
        if(checkItems.length > 0){
            checkItems.forEach(el => {

                el.addEventListener("click",() => {
                    const names = el.getAttribute("data-check-items")
                    const allCheckButton = document.querySelector("[data-all-checked-button='" + names + "']")
                    
                    const items = document.querySelectorAll("[name='" + names + "']")
                    
                    let isAll = true
                    Array.from(items).some(item => {
                        if( !item.checked ){
                            isAll = false
                            return true
                        }
                    })
                    if(isAll){
                        allCheckButton.classList.add("-active")
                    }else{
                        allCheckButton.classList.remove("-active")
                    }
                })

                
            })
        }
    }
    
}